import type { RouteObject } from 'react-router-dom'
import { lazy, Suspense } from 'react'
import Home from '@/pages/Home'
import { useRoutes } from 'react-router-dom'

const TdeeBmrCalculator = lazy(() => import('@/pages/TdeeBmrCalculator'))
const BlogTdeeVsBmi = lazy(() => import('@/pages/BlogTdeeVsBmi'))
const History = lazy(() => import('@/pages/History'))

function LazyPage({ children }: { children: React.ReactNode }) {
  return (
    <Suspense
      fallback={
        <div className="min-h-screen flex items-center justify-center bg-white">
          <div className="flex flex-col items-center gap-3">
            <div className="w-10 h-10 rounded-full border-3 border-emerald-500 border-t-transparent animate-spin" />
            <p className="text-sm text-slate-500 font-medium">Loading...</p>
          </div>
        </div>
      }
    >
      {children}
    </Suspense>
  )
}

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  {
    path: '/tdee-bmr-calculator',
    element: <LazyPage><TdeeBmrCalculator /></LazyPage>,
  },
  {
    path: '/blog/tdee-vs-bmi-fat-intake',
    element: <LazyPage><BlogTdeeVsBmi /></LazyPage>,
  },
  {
    path: '/history',
    element: <LazyPage><History /></LazyPage>,
  },
]

function App() {
  return useRoutes(routes)
}

export default App